import { PlannedMealCalendar } from "@corpuscomplete/core-ui/nutrition/planned-meal/calendar";
import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/personal/planned-meals/")({
  loader: async ({ context: { zero, actor } }) => {
    if (!zero) return;
    PlannedMealCalendar.preload(zero, {
      scopeId: actor.userId,
      focusedDate: Temporal.Now.plainDateISO(),
      timeZone: Temporal.Now.timeZoneId(),
    });
  },
  component: () => (
    <Navigate
      to="/personal/planned-meals/$date"
      params={{ date: Temporal.Now.plainDateISO() }}
      replace
    />
  ),
});
